import { AuthToken, PageStateModel } from '@libs/shared/models';

// eslint-disable-next-line @typescript-eslint/typedef
export const DebuggerOptionNames = [
  'bffEnv', 'pageId', 'customerNumber', 'showNav',
] as const;

export type DebuggerOptionName = typeof DebuggerOptionNames[number];

export type DebuggerOptions = Record<DebuggerOptionName, string>;

export interface DebuggerAuthState {
  token?: AuthToken;
  customerNumber: string;
}

export interface DebuggerPageState {
  bffEnv: string;
  pageId: string;
  showNav: boolean;
  page: PageStateModel;
}
